import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { VARIANT, SIZE, Tag, KIND } from 'baseui/tag';
import { mergeOverrides } from '../../overrides.js';
import 'baseui';
import '../../theme/olx-theme/base-theme.js';
import '../../theme/olx-theme/theme.js';
import { useResolvedStyle, mergeStyles } from '../../theme/utils.js';
import '../../theme/types.js';
import { ActionIcon } from './action-icon.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const getSizeStyles = (theme, size) => {
  switch (size) {
    case SIZE.large:
      return __spreadProps(__spreadValues({}, theme.typography.p2), {
        paddingLeft: theme.space[20],
        paddingRight: theme.space[20]
      });
    case SIZE.small:
      return {
        paddingLeft: theme.space[8],
        paddingRight: theme.space[8],
        height: theme.space[26]
      };
    case SIZE.medium:
    default:
      return {
        paddingLeft: theme.space[16],
        paddingRight: theme.space[16]
      };
  }
};
const getRootStyles = ({ $theme, $variant, $isSelected, $disabled, $size }) => {
  const commonStyles = __spreadValues(__spreadProps(__spreadValues({}, $theme.typography.p3), {
    borderBottomLeftRadius: $theme.radii[4],
    borderBottomRightRadius: $theme.radii[4],
    borderTopLeftRadius: $theme.radii[4],
    borderTopRightRadius: $theme.radii[4],
    borderBottomWidth: "0px",
    borderLeftWidth: "0px",
    borderRightWidth: "0px",
    borderTopWidth: "0px",
    marginLeft: "0px",
    marginRight: "0px",
    marginTop: "0px",
    marginBottom: "0px"
  }), getSizeStyles($theme, $size));
  switch ($variant) {
    case VARIANT.outlined:
      return __spreadValues(__spreadProps(__spreadValues({}, commonStyles), {
        outline: `${$theme.colors["borders-global-secondary"]} solid 1px`
      }), $isSelected && {
        backgroundColor: $theme.colors["background-brand-secondary-light"],
        outline: `${$theme.colors["borders-brand-secondary"]} solid 1px`
      });
    case VARIANT.solid:
      return __spreadValues(__spreadValues(__spreadValues(__spreadValues({}, commonStyles), $isSelected && {
        backgroundColor: $theme.colors["background-brand-secondary"]
      }), $disabled && {
        backgroundColor: $theme.colors["background-brand-disabled"]
      }), $disabled && $isSelected && {
        backgroundColor: $theme.colors["background-brand-secondary-light"]
      });
    case VARIANT.light:
      return __spreadValues(__spreadValues(__spreadProps(__spreadValues({}, commonStyles), {
        backgroundColor: $theme.colors["background-global-primary"]
      }), $isSelected && {
        backgroundColor: $theme.colors["background-brand-secondary"]
      }), $disabled && $isSelected && {
        backgroundColor: $theme.colors["background-brand-secondary-light"]
      });
    default:
      return commonStyles;
  }
};
const Chip = forwardRef((_a, ref) => {
  var _b = _a, { variant = VARIANT.outlined, size = SIZE.medium, overrides, selected, $style } = _b, props = __objRest(_b, ["variant", "size", "overrides", "selected", "$style"]);
  const resolvedStyle = useResolvedStyle($style);
  return jsx(Tag, __spreadValues({ ref, closeable: false, kind: KIND.primary, variant, size, overrides: mergeOverrides({
    Root: {
      style: (styleProps) => mergeStyles(getRootStyles(__spreadProps(__spreadValues({}, styleProps), { $isSelected: selected })), resolvedStyle)
    },
    Text: {
      style: {
        maxWidth: "initial"
      }
    },
    ActionIcon: {
      component: ActionIcon,
      props: {
        size
      }
    },
    Action: {
      style: ({ $theme }) => ({
        marginLeft: $theme.space[8]
      })
    }
  }, overrides) }, props));
});
const CHIP_VARIANT = VARIANT;
const CHIP_SIZE = SIZE;

export { CHIP_SIZE, CHIP_VARIANT, Chip };
